import { createApi } from '@core/fetch'

export default {
  activityList: createApi(
    '/hms/hljUtils/appApi/admin/merchantWcdActivity/activityList'
  ),
  // 删除活动
  delActivity: createApi(
    '/hms/hljUtils/appApi/admin/merchantWcdActivity/delActivity'
  ),
  // 获取模板列表
  getTemplateList: createApi(
    '/hms/hljUtils/appApi/admin/merchantWcdActivityTemplate/activityTemplateList'
  )
}
